import { render, staticRenderFns } from "./LawAuthorityTypeList.vue?vue&type=template&id=ba7f489e&"
import script from "./LawAuthorityTypeList.vue?vue&type=script&lang=js&"
export * from "./LawAuthorityTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthorityTypeList.vue?vue&type=style&index=0&id=ba7f489e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports